<template>
  <div id="app" class="row">
<Main></Main>

    <router-view />


  </div>
</template>
<script>
  import Main from "./views/Main"

  export default{

      component:{
          Main
      },
  }
</script>
<style>

    @import "assets/borders.css";
    @import "assets/loader.css";
    @import "assets/padding.css";
    @import "assets/margin.css";
    @import "assets/password-meter.css";
    @import "assets/style.css";
    @import "assets/vert-offset.css";

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
    }
    #nav {
        padding: 30px;
    }

</style>
